import React, { Component } from "react"
import { withTranslation } from "react-i18next";
import './SocialIcons.scss';

class SocialIcons extends Component {  

    render() {
        const { t } = this.props;
        return (
            <div className="outer-icon-container">
                <ul className="icon-container ps-0">
                    {t("footer#socialMediaLinks", {returnObjects: true}).map((link, i)=>
                    <li key={i}>
                        <a href={link.url} target="_blank" rel="noreferrer">
                            <span className={`icon-${link.icon}`}></span>
                        </a>
                    </li>
                    )}
                </ul>
            </div>
        );
    }
}

export default withTranslation()(SocialIcons);